import { Box, Text, CloudinaryImage, Stack } from '@stitch-fix/mode-react';
import styles from './PhotoTips.module.scss';
export type BusinessLine = 'WOMENS' | 'MENS';
export type PhotoTipsMode = 'fullBody' | 'headshot';
export type PhotoTipsProps = {
  businessLine: string; // accept any string from GraphQL
  mode: PhotoTipsMode;
  showProfileSettingsCopy?: boolean;
};
const baseUrl = 'https://res.cloudinary.com/stitch-fix/image/upload/';
const tips: Record<PhotoTipsMode, string[]> = {
  fullBody: ['Full-body, head-to-toe', 'Good lighting', 'Natural pose, fitted clothes', 'Just you—no pets or people'],
  headshot: ['Full-color', 'Good lighting', 'No hats or sunglasses', 'Just you—no pets or people']
};
const photos = {
  WOMENS: {
    headshot: {
      mediaPath: '/v1771521107/vision/assets/womens_headshot.png',
      altText: 'Womens headshot polaroid'
    },
    fullBody: {
      mediaPath: '/v1771521107/vision/assets/womens_full_body.png',
      altText: 'Womens full body polaroid'
    }
  },
  MENS: {
    headshot: {
      mediaPath: '/v1771520988/vision/assets/mens_headshot.png',
      altText: 'Mens headshot polaroid'
    },
    fullBody: {
      mediaPath: '/v1771520988/vision/assets/mens_full_body.png',
      altText: 'Mens full body polaroid'
    }
  }
};
const isPhotoBusinessLine = (bl: string): bl is BusinessLine => bl === 'WOMENS' || bl === 'MENS';
const PhotoTips = ({
  businessLine,
  mode,
  showProfileSettingsCopy = true
}: PhotoTipsProps) => {
  if (!isPhotoBusinessLine(businessLine)) return null;
  const photo = photos[businessLine][mode];
  return <Box className={styles.container} bgColor="gray-99" py={1.5} px={1}>
      <Box display="flex" style={{
      width: '100%',
      justifyContent: 'space-between',
      gap: '2rem'
    }}>
        <Box style={{
        flex: 1
      }}>
          <Stack spacing={0.5}>
            <Text setting="title-xxsmall" color="blue-45" mb={0.5}>
              Tips for a great pic
            </Text>
            <Box as="ul" className={styles.list}>
              {tips[mode].map((tip, idx) =>
            // eslint-disable-next-line react/no-array-index-key
            <Text key={idx} as="li" setting="body-xsmall">
                  {tip}
                </Text>)}
            </Box>
          </Stack>
        </Box>
        <Box className={styles.imageContainer}>
          <CloudinaryImage baseUrl={baseUrl} mediaPath={photo.mediaPath} alt={photo.altText} sizes={{
          sm: 91
        }} />
        </Box>
      </Box>
      {showProfileSettingsCopy && <Text setting="body-xsmall" mt={1}>
          You can update your photo (and add a full-body image) later in your
          profile settings.
        </Text>}
    </Box>;
};
export default PhotoTips;